/* ==========================================================================
   Mini Maxx — header
   Two disclosures: the mobile nav drawer, and the submenu under any nav item
   that has children. Both animate in CSS; this file only owns state.
   Re-binds on shopify:section:load so it survives theme-editor reloads.
   ========================================================================== */

(function () {
  'use strict';

  /* --- Mobile drawer ----------------------------------------------------- */

  function bindDrawer(root) {
    var toggle = root.querySelector('[data-mm-nav-toggle]');
    if (!toggle || toggle.dataset.mmBound === 'true') return;

    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;

    toggle.dataset.mmBound = 'true';

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      nav.setAttribute('data-mm-open', String(open));
      if (!open) closeAllSubs(root);
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      toggle.focus();
    });

    // Following a link should not leave the drawer hanging open on same-page
    // anchors. The submenu caret is a button, so it is not caught here.
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });
  }

  /* --- Submenus ----------------------------------------------------------- */

  function closeAllSubs(root, except) {
    root.querySelectorAll('[data-mm-sub-toggle]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.removeAttribute('data-mm-open');
    });
  }

  function bindSubs(root) {
    root.querySelectorAll('[data-mm-sub]').forEach(function (item) {
      var btn = item.querySelector('[data-mm-sub-toggle]');
      if (!btn || btn.dataset.mmBound === 'true') return;

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      btn.dataset.mmBound = 'true';

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        // One submenu at a time, so two panels never overlap on desktop.
        closeAllSubs(root, btn);
        btn.setAttribute('aria-expanded', String(!open));
        if (open) {
          panel.removeAttribute('data-mm-open');
        } else {
          panel.setAttribute('data-mm-open', 'true');
        }
      });

      // Leaving the item entirely resets the clicked-open state, so a panel
      // opened by click does not stay pinned once the pointer moves away.
      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(max-width: 899px)').matches) return;
        btn.setAttribute('aria-expanded', 'false');
        panel.removeAttribute('data-mm-open');
      });
    });
  }

  /* --- Global dismissal ---------------------------------------------------- */

  function bindGlobal(root) {
    if (root.dataset.mmGlobalBound === 'true') return;
    root.dataset.mmGlobalBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllSubs(root);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-mm-sub]')) closeAllSubs(root);
    });
  }

  function init() {
    document.querySelectorAll('[data-mm-header]').forEach(function (root) {
      bindDrawer(root);
      bindSubs(root);
      bindGlobal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
